import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import '../styles/hero.css';
 

const heroSlides = ['/images/bg1.jpg', '/images/bg2.jpg', '/images/bg3.jpg'];

const Hero = ({ language }) => {
  return (
    <section className="hero-slideshow">
      <Swiper
        modules={[Autoplay, Pagination]}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        speed={900}
        grabCursor={true}
        loop={true}
        className="hero-swiper"
      >
        {heroSlides.map((img, index) => (
          <SwiperSlide key={index}>
            <div className="hero-slide-image kenburns" style={{ backgroundImage: `url(${img})` }} />
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Hero;
